import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import auth from "./auth";
import chefs from "./chefs";
import posts from "./posts";
import user from "./user";
import bookings from "./bookings";
// import chat from "./chat";
import schedule from './schedule';

export default combineReducers({
  routing: routerReducer,
  auth,
  bookings,
  chefs,
  posts,
  user,
  schedule,
});
